module.exports = __webpack_public_path__ + "static/media/dots_6x19.fd918c59.svg";